export const LOCALE_SEPARATOR = "-";
export function formatCountryCode(countryCode) {
    return countryCode.toUpperCase();
}
export function formatLangCode(langCode) {
    return langCode.toLowerCase();
}
export function formatLocaleCode(langCode, countryCode) {
    return [
        formatLangCode(langCode),
        formatCountryCode(countryCode),
    ].join(LOCALE_SEPARATOR);
}
export function normalizeLocaleSeparator(locale) {
    return locale.replace(/_/g, LOCALE_SEPARATOR);
}
export class LocaleObject {
    constructor(langCode, countryCode) {
        this.langCode = formatLangCode(langCode);
        this.countryCode = countryCode ? formatCountryCode(countryCode) : undefined;
        if (this.countryCode)
            this.localeCode = formatLocaleCode(this.langCode, this.countryCode);
        else
            this.localeCode = this.langCode;
    }
    valueOf() {
        return this.localeCode;
    }
    toString() {
        return this.localeCode;
    }
    toJSON() {
        return this.localeCode;
    }
    equals(other) {
        return this.valueOf() === other.valueOf();
    }
    static parse(locale) {
        const parts = normalizeLocaleSeparator(locale)
            .split(LOCALE_SEPARATOR);
        if (parts.length == 0 || parts.length > 2)
            throw new Error(`Invalid locale format: ${locale}`);
        const langCode = parts[0];
        if (!langCode)
            throw new Error(`Invalid locale format: ${locale}`);
        const countryCode = parts[1];
        return new LocaleObject(langCode, countryCode);
    }
    static tryParse(locale) {
        try {
            return this.parse(locale);
        }
        catch (e) {
            return undefined;
        }
    }
}
export class WellKnownLocaleObject extends LocaleObject {
    constructor(displayName, langCode, countryCode) {
        super(langCode, countryCode);
        this.displayName = displayName;
    }
    static fromLocale(locale, displayName) {
        return new WellKnownLocaleObject(displayName, locale.langCode, locale.countryCode);
    }
}
//# sourceMappingURL=Locale.js.map